import { useFeatureIsOn } from '@growthbook/growthbook-react';

type isOnboardingOn = boolean;

export const useOnboarding2 = (): isOnboardingOn => {
  const isOn = useFeatureIsOn('onboarding-2');

  return isOn;
};
